import api from '@/services/api';

import { type MaturityModel } from '../types';

const BASE_URL = 'maturityModels';

export const getMaturityModels = async () => {
  return await api.get<MaturityModel[]>(BASE_URL);
};

export const getMaturityModel = async (id: number) => {
  return await api.get<MaturityModel>(`${BASE_URL}/${id}`);
};

export const updateMaturityModel = async (model: MaturityModel) => {
  await api.put(`${BASE_URL}/${model.idMaturityModel}`, model);
  return model;
};

export const createMaturityModel = async (model: MaturityModel) => {
  return await api.post<MaturityModel>(BASE_URL, model);
};

export const deleteMaturityModel = async (id: number) => await api.delete(`${BASE_URL}/${id}`);

export const canViewMaturityModelPage = async () => {
  return await api.get<boolean>(`${BASE_URL}/can-view-maturity-screen`);
};
